import { CSSProperties } from 'react'

import { getEnvVar } from './env'

const MYTOVALA_IMAGES_URL = `${getEnvVar('CDN_URL')}/mytovala/images`

export const IMAGES = {
  MEAL_PLAN_PREFERENCES_START: `${MYTOVALA_IMAGES_URL}/meal-plan-preferences-start-v2.jpg`,
  WANT_MORE_MEALS: `${MYTOVALA_IMAGES_URL}/more_meals_module.png`,
}

export function getDarkenedBGImage({
  imageURL,
}: {
  imageURL: string
}): CSSProperties {
  return {
    backgroundImage: `linear-gradient(0deg, rgba(57, 57, 45, 0.35), rgba(57, 57, 45, 0.35)), url(${imageURL})`,
  }
}
